import { render, staticRenderFns } from "./user_index.vue?vue&type=template&id=5c9e67d0&"
import script from "./user_index.vue?vue&type=script&lang=js&"
export * from "./user_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports